import { QueryObject } from '../helpers/helpers';

/* eslint-disable func-names */
/* eslint-disable no-undef */
const locationTabs = () => {
  (function ($) {
    // DOM elements
    const $toggleMobileListButton = $('.js-change-location-button');
    // the active tab that only appears on mobile
    const $activeTabMobile = $('.c-location-tabs__mobile-current');
    const $activeLabelMobile = $('.c-location-tabs__mobile-current-label');
    // tabs buttons
    const $tabButtons = $('.js-location-tab');
    // active classes
    const tabActiveClass = 'c-location-tabs__tab--active';
    const contentActiveClass = 'o-tab-content--active';

    const desktopMediaQuery = '(min-width: 768px)';

    const queryObject = new QueryObject();

    /**
     * Tab class contains name id and class name
     */
    class Tab {
      constructor(id, name, elem) {
        this.id = id;
        this.name = name;
        this.elem = elem;
      }

      get className() {
        return `c-location-tabs__${this.name.replace(' ', '-').toLowerCase()}`;
      }
    }

    class TabList {
      constructor(listElement, contentElement) {
        this.listElement = listElement;
        this.contentElement = contentElement;
        this.active = '';
        this.mobileListOpen = false;

        this.tabs = $(this.listElement).find('li').toArray().map(item => (
          new Tab(
            `${$(item).attr('data-tab')}`,
            $(item).text().trim(),
            item,
          )
        ));
      }

      // set the active tab
      setActive(id) {
        // decode is necessary for non-latin characters to work
        this.active = `${window.decodeURIComponent(id)}`;
        this.updateDOM();
      }

      // show or hide the tab list on mobile
      toggleMobileList(refresh = false) {
        const className = 'js-location-open';
        const isDesktop = window.matchMedia(desktopMediaQuery).matches;
        const $elem = $(this.listElement);

        // only toggle the classname if refresh is false
        if (!refresh) {
          if ($elem.hasClass(className)) {
            // list is open now close it
            $elem.removeClass(className);
            $toggleMobileListButton.text($toggleMobileListButton.attr('data-open-label'));
          } else {
            // list is closed now open it
            $elem.addClass(className);
            $toggleMobileListButton.text($toggleMobileListButton.attr('data-close-label'));
          }
        }

        // Only modify inline styles on mobile
        if (!isDesktop) {
          if ($elem.hasClass(className)) {
            $elem.css({ height: `${$elem[0].scrollHeight}px` });
          } else {
            $elem.css({ height: '' });
          }
        }
      }

      showOnDesktop() {
        const isDesktop = window.matchMedia(desktopMediaQuery).matches;
        const $elem = $(this.listElement);

        if (isDesktop) {
          // remove inline styles on desktop
          $elem.css({ height: '' });
        } else {
          this.toggleMobileList(true);
        }
      }

      updateDOM() {
        let activeTab = this.tabs.find(item => item.id === this.active);

        // if the selected tab does not exist select the first tab
        if (!activeTab) {
          [activeTab] = this.tabs;
        }

        const isDesktop = window.matchMedia(desktopMediaQuery).matches;

        const $tabs = $(this.tabs.map(item => item.elem));
        const $activeTab = $(activeTab.elem);
        const $content = $('.o-tab-content');
        const $activeContent = $(`.o-tab-content[data-tab='${$activeTab.attr('data-tab')}']`);
        const $placeholderContent = $('.o-tab-content[data-tab=placeholder]');

        // console.log($activeContent.length);

        // Update the active tab label on mobile
        $activeLabelMobile.text(activeTab.name);

        // remove active class from all tabs
        $tabs.removeClass(tabActiveClass);
        $content.removeClass(contentActiveClass);

        // add active class to selected tab
        $activeTab.addClass(tabActiveClass);
        $activeContent.addClass(contentActiveClass);

        // Show the placeholder tab if the active tab doesn't exist
        if (!$activeContent.length) {
          $placeholderContent.addClass(contentActiveClass);
        }

        // remove all country class names from the active tab on mobile
        for (let i = 0; i < this.tabs.length; i++) {
          const elem = this.tabs[i];
          $activeTabMobile.removeClass(elem.className);
        }

        // add the country class name of the selected tab to the active tab on mobile
        $activeTabMobile.addClass(activeTab.className);

        if (!isDesktop) {
          // hide tab list and show active tab on mobile
          this.toggleMobileList();
        }
      }
    }

    const tabs = new TabList(
      $('.c-location-tabs__tab-list')[0],
      $('.c-choose-location__bottom-inner')[0],
    );

    if (tabs.tabs.length) {
      // Fix for location page translations
      $('.c-location-tabs__tab').each(function () {
        const rel = $(this).attr('rel');
        const dataTab = $(this).attr('data-tab');
        $(`li.c-location-card.cn-${rel}`).parents('div.o-tab-content').attr('data-tab', dataTab);
      });

      if (queryObject.params.location) {
        tabs.setActive(queryObject.params.location);
        // scroll to the location section
        setTimeout(() => {
          const $target = $('.c-choose-location');
          $('body,html').animate(
            { scrollTop: $target.offset().top - 50 }, 600,
          );
        }, 300);
      } else {
        // select the first tab
        tabs.setActive(tabs.tabs[0].id);
      }
    }

    $(window).on('resize', tabs.showOnDesktop.bind(tabs));

    // click change/close button to show/hide the tab list on mobile only
    $toggleMobileListButton.on('click', () => {
      tabs.toggleMobileList();
    });

    // click on a tab to show its content
    $tabButtons.on('click', (e) => {
      const $target = $(e.currentTarget);
      queryObject.set({ location: $target.attr('data-tab') }, a => tabs.setActive(a.location));
    });

    // select the correct tab when a user presses the back/forward browser buttons
    $(window).on('popstate', () => {
      queryObject.get((a) => {
        if (a.location) {
          tabs.setActive(a.location);
        }
      });
    });
  }(jQuery));
};

export default locationTabs;
